export const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: true,
      label: "S.no",
    },
    {
      id: "patient",
      numeric: false,
      disablePadding: true,
      label: "Patient",
    },
    {
      id: "branch",
      numeric: true,
      disablePadding: false,
      label: "Branch",
    },
    {
      id: "consultant",
      numeric: true,
      disablePadding: false,
      label: "Consultant",
    },
    // {
    //     id: "procedures",
    //     numeric: true,
    //     disablePadding: false,
    //     label: "Procedures",
    //   },
      {
        id: "datetime",
        numeric: true,
        disablePadding: false,
        label: "Date & Time",
      },
    {
      id: "amount",
      numeric: true,
      disablePadding: false,
      label: "Amount(₹)",
    },
    {
      id: "action",
      numeric: true,
      disablePadding: false,
      label: "Action",
    },
  ];
  